import { EntityType } from '@frontend/common';
import { DeviceClient } from '@frontend/device/api';
import { Device } from '@frontend/device/types';
import { useReactiveObject, useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useDevice:request': CustomEvent<string>;
    }
}

const REQUEST_DEVICE_EVENT = 'useDevice:request';
const STORAGE_KEY = 'DVC_REQ';

export function deviceRequest(deviceId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_DEVICE_EVENT, { detail: deviceId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function DeviceResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_DEVICE_EVENT, EntityType.DEVICE, (ids) => DeviceClient.resolveDevices(ids), props.dispatch);
    return <></>;
}

interface UseDeviceResolverProps {
    deviceId?: string;
    fetchOnload?: boolean;
}
interface UseDeviceResolverReturn {
    device: Device | null;
    initialising: boolean;
    isLoading: boolean;
}

/**
 * @description DeviceResolver must be present in the app for this to work.
 */
export function useReactiveDevice({deviceId, fetchOnload = false}: UseDeviceResolverProps): UseDeviceResolverReturn {
    const { object: device, initialising, isLoading } = useReactiveObject<Device>({ id: deviceId, entity_type: EntityType.DEVICE, fetchOnload, resolveFunction: deviceRequest });
    return { device, initialising, isLoading };
}